// 引入jquery
import jquery from "@/views/webpage/assets/js/jquery-3.6.1.slim.min.js"; // 引入 jquery
import $ from "jquery"; // 引入 jQuery
window.$ = window.jQuery = $; // 设置全局 jQuery
import "@/views/webpage/assets/css/bootstrap.min.css";
import { createApp } from "vue";
import SvgIcon from "@/icons";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import "@/router/permission.js";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import "element-plus/dist/index.css";
import "@/assets/styles_admin/border.css";
import "@/assets/styles_admin/reset.css";
// import "@/views/webpage/assets/css/global_style.css"

// import "@/views/webpage/assets/js/bootstrap.min.js"; // 引入 Bootstrap JS

/* swiper */ import "swiper/swiper.min.css";

/* 重置样式 */
import "@/views/webpage/assets/css/reset.min.css";

/* 官网响应式样式：电脑/平板/手机 */
import "@/views/webpage/assets/css/responsive.css";

/* 官网字体与排版优化 */
import "@/views/webpage/assets/css/typography.css";

/* animate.css */
import "wow.js/css/libs/animate.css";

// 创建 Vue 应用
const app = createApp(App);
SvgIcon(app);

app.use(store);
app.use(router);
app.use(ElementPlus, {
  locale: zhCn,
});
app.mount("#app");
